import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { GenericResponseDto } from "../models/generic-response.dto";
import { CopyLinesDto } from "../models/orders/copyLinesDto";
import { CopySoLinesDto } from "../models/orders/copySoLinesDto";
import { CreateSalesOrderLineResponseDto } from "../models/orders/createSalesOrderLineResponseDto";
import { GetSaleOrderDtoWIthType } from "../models/orders/getSaleOrderDtoWIthType";
import { GetSalesOrderWithLinesDto } from "../models/orders/getSalesOrderWithLinesDto";

@Injectable({
  providedIn: "root",
})
export class CopyLinesService {
  private saleOrderManagementBaseURL =
    environment.baseUrl + "/SalesOrderManagement";

  private quoteManagementBaseURL = environment.baseUrl + "/QuotesManagement";

  constructor(private _http: HttpClient) {}

  GetAllSalesOrderWithLines(): Observable<
    GenericResponseDto<GetSalesOrderWithLinesDto[]>
  > {
    return this._http.get<GenericResponseDto<GetSalesOrderWithLinesDto[]>>(
      this.saleOrderManagementBaseURL + "/GetAllSalesOrderWithLines"
    );
  }

  addLineData(
    payload: CopyLinesDto
  ): Observable<GenericResponseDto<CreateSalesOrderLineResponseDto>> {
    return this._http.post<GenericResponseDto<CreateSalesOrderLineResponseDto>>(
      this.saleOrderManagementBaseURL + "/CopyLines",
      payload
    );
  }

  getAllSalesOrderHeader(): Observable<
    GenericResponseDto<GetSaleOrderDtoWIthType[]>
  > {
    return this._http.get<GenericResponseDto<GetSaleOrderDtoWIthType[]>>(
      this.saleOrderManagementBaseURL + "/GetSaleOrderInformation"
    );
  }

  getLineAgainstSaleOrderHeader(
    payload: string
  ): Observable<GenericResponseDto<CopySoLinesDto>> {
    return this._http.get<GenericResponseDto<CopySoLinesDto>>(
      this.saleOrderManagementBaseURL +
        "/GetSalesOrderLineBySalesOrderId?salesOrderId=" +
        payload
    );
  }

  getLineAgainstQuoteHeader(
    payload: string
  ): Observable<GenericResponseDto<CopySoLinesDto>> {
    return this._http.get<GenericResponseDto<CopySoLinesDto>>(
      this.quoteManagementBaseURL +
        "/GetQuotesLinesBySalesOrderId?salesOrderId=" +
        payload
    );
  }
}
